import { createStyles, makeUiStyles } from "../../styles/styles";
import { RadioGroupVariant } from "./tools/RadioGroup.const";
import { StylesIndexInjections } from 'common-react';

const isHorizontalVariant = (variant: RadioGroupVariant) => variant === RadioGroupVariant.HORIZONTAL;

export default makeUiStyles(() => createStyles({
  root: {
    display: 'flex',
    flexDirection: ({ variant }: { variant: RadioGroupVariant }) => isHorizontalVariant(variant) ? 'row' : 'column',
    gap: ({ variant }: { variant: RadioGroupVariant }) => isHorizontalVariant(variant) ? 24 : 16,
    '& .MuiFormControlLabel-root': {
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
    },
    '& > .FieldErrorMessage': {
      marginTop: 16,
    },
  }
}), { name: 'RadioGroup', index: StylesIndexInjections.UI_MOLECULES });
